import * as React from 'react';
import { Partner } from '../../amorg-common';
import { AnonymousLayout } from './wrapperLayouts/AnonymousLayout';
import { PublicPageProvider } from '../_contexts/PublicPageContext';


export function PublicPageWrapper({
    siteId, 
    partner,
    wide,
    customControls,
    children
}: React.PropsWithChildren<{
    siteId?: string, 
    partner?: Partner,
    wide?: boolean,
    customControls?: React.ReactNode
}>): JSX.Element {
    
    return (
        <PublicPageProvider siteId={siteId} partner={partner}>
            <AnonymousLayout wide={wide} customControls={customControls}>
                {children}
            </AnonymousLayout>
        </PublicPageProvider>
    );
}


